import { DeviceSettingsType } from '@signageos/common-types/dist/Device/Settings/DeviceSettingsType';

import { AssignedRunners } from '../../../Runner/runnerSaga';
import Responsibility from '../../../Feature/Responsibility';
import ManagementCapability from '../../../NativeDevice/Management/ManagementCapability';
import Property from '../../../Property/Property';
import { createDevicePolicySaga, CheckAndSetResult } from '../Policy/devicePolicySagas';
import IPolicyCheckAndSetProperties from '../Policy/IPolicyCheckAndSetProperties';

export const deviceRunnerPolicySaga = createDevicePolicySaga(
	DeviceSettingsType.RUNNER,
	Responsibility.RUNNERS,
	ManagementCapability.RUNNERS,
	checkAndSetRunnerSettings,
);

export async function* checkAndSetRunnerSettings(properties: IPolicyCheckAndSetProperties<DeviceSettingsType.RUNNER>) {
	const runnerSettings = properties.policy.value;
	const assignedRunners: AssignedRunners = await properties.propertyStorage.getValueOrDefault(Property.DEVICE_RUNNERS, {});
	const runnerForPolicy = Object.values(assignedRunners).find((runner) => runner.runnerUid === runnerSettings.runnerUid);

	const iframeId = runnerForPolicy?.md5Checksum;
	const iframe = document.getElementById(iframeId!) as HTMLIFrameElement;
	const iframeWindow = iframe.contentWindow as any;

	if (!(iframeWindow && iframeWindow.sosRunner && iframeWindow.sosRunner.run)) {
		return CheckAndSetResult.CHANGED;
	}
	return CheckAndSetResult.ALREADY_APPLIED;
}
